import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EMPTY, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { GroupSharingComponent } from '../group-sharing.component';
import { GroupSharingService, WatchPartyType } from '../group-sharing.service.component';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HotToastService } from '@ngneat/hot-toast';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { MyTicketCinejoy } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import {
  MyTicketScreeningParties
} from 'src/app/shared/cinejoy/spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { InvitationSource, WatchPartyRequestFlow } from 'src/app/core/models/common.models';
import { UserInvitationService } from 'src/app/core/services/user.invitation.service';
import * as moment from 'moment-timezone';

export interface User {
  name: string;
  value: string;
  id: string;
  userId: string
}

@Component({
  selector: 'app-create-group-popup',
  templateUrl: './create-group-popup.component.html',
  styleUrls: ['./create-group-popup.component.scss']
})

export class CreateGroupPopupComponent implements OnInit {
  token: any;
  meetingId: any;

  constructor(public dialogRef: MatDialogRef<CreateGroupPopupComponent>,
    public groupSharingService: GroupSharingService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private toast: HotToastService,
    public spotlightService: SpotlightService,
    private route: ActivatedRoute,
    private agileIntegration: AgileIntegrationService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  filteredOptions: any;
  options: User[] = [];
  myControl = new FormControl();
  invitationEmail = new FormControl('', Validators.email);
  invitedEmails: string[] = [];
  selectedUsers: any = [];
  selectedUsersIds: any = []
  @ViewChild('fruitInput') userDetailsInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  eventDetails: any;
  groupName: string;
  eventId: string;
  exsistingGroup: boolean = false;
  invalidUserIds: boolean = false;
  invalidGroupName: boolean = false;
  isFormSubmitted: boolean = false;
  loading: boolean = true;
  permissionAllowed: boolean = false;
  cinejoyPremierDetails: any;
  groupshareUrl: any;
  userDetails: any;
  filterHasLength = true;
  startDate: any
  endDate:any
  timezone: any
  userEmail:any
  email = false

  ngOnInit(): void {
    this.getUserDetails()
    this.getPremierInfo()
    this.getStreamingLink()
    this.fetchTickets()
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(600),
      distinctUntilChanged(),
      switchMap(val => {
        return this.filter(val || '')
      })
    );

    this.groupshareUrl = `/cinejoy/group-share-info-page`
  }

  closeDialog() {
    this.dialogRef.close()

  }

  getToken() {
    this.groupSharingService.generateToken().subscribe((res) => {
      this.token = res.token;
    })
  }

  createMeeting() {
    let obj = { "token": this.token, 'region': "sg001" }
    this.groupSharingService.createMeeting(obj).subscribe((res) => {
      this.meetingId = res.meetingId;
      this.validateMeeting()
    })
  }

  validateMeeting() {
    let obj = { "token": this.token }
    this.groupSharingService.validateMeeting(this.meetingId, obj).subscribe((res) => {

      res.startMeeting = true;
      res.token = this.token;
      res.entryRequested = false;
      this.dialogRef.close(res)
    })
  }

  inviteUser($event: any) {
    $event.stopImmediatePropagation();

    if (!this.invitationEmail.valid) {
      return;
    }

    if (this.invitedEmails.includes(this.invitationEmail.value)) {
      this.openSnackBar('User already added for invitation', '');
      return;
    }

    this.invitedEmails.push(this.invitationEmail.value);
    this.invitationEmail.setValue('', { emitEvent: true });
    this.myControl.reset('', { emitEvent: true });
  }

  removeInvitation(email: string) {
    this.invitedEmails.splice(this.invitedEmails.findIndex(emailEntry => emailEntry === email), 1);
  }

  getCustomRoomId() {
    this.isFormSubmitted = true;

    //this.invalidUserIds = this.selectedUsersIds.length <= 0 || this.invitedEmails.length <= 0;
    this.invalidGroupName = this.groupName == null || this.groupName.length < 3;

    if (this.groupName == null || this.groupName.length < 3 || this.groupName.length >= 30) {
      this.invalidGroupName = true;
      return;
    } else {
      this.invalidGroupName = false;
    }
    if (this.selectedUsersIds.length <= 0) {
      if(this.invitedEmails.length <= 0){
        this.invalidUserIds = true;
        return;
      }
    }

    if (!this.data.isPreScheduleEvent) {
      navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
        this.permissionAllowed = true;
        if (this.router.url.includes('/cinejoy/premiere/theater/')) {
          this.eventId = this.router.url.split('/')[4]
        } else {
          this.eventId = this.data.eventId
        }
        const obj = {
          "eventId": this.eventId,
          "partyType": "PRIVATE",
          "description": this.groupName,
          "participantIds": this.selectedUsersIds,
          "partyTypeEnum": "PRIVATE"
        }

        this.groupSharingService.createCustomRoomId(obj).subscribe((res) => {
          this.eventDetails = res;
          this.getHostToken();
          this.toast.info(
            'Successfully created Group',
            {
              theme: 'snackbar',
              position: 'top-right',
              duration: 3000
            }
          );
        }, err => {
          this.toast.info(
            err.error,
            {
              theme: 'snackbar',
              position: 'top-right',
              duration: 3000
            }
          );
        });
      }).catch((err) => {
        console.error(`you got an error: ${err}`)
        this.toast.show(`Please allow Camera and Microphone to start the group sharing on spotlight.`, {
          theme: 'snackbar',
          position: 'top-right',
          duration: 5000
        })
        this.permissionAllowed = false;
      });
    } else {
      if (this.router.url.includes('/cinejoy/premiere/theater/')) {
        this.eventId = this.router.url.split('/')[4]
      } else {
        this.eventId = this.data.eventId
      }
      const obj = {
        "eventId": this.eventId,
        "partyType": "PRIVATE",
        "description": this.groupName,
        "participantIds": this.selectedUsersIds,
        "partyTypeEnum": "PRIVATE"
      }

      this.groupSharingService.createCustomRoomId(obj).subscribe((res) => {
        this.eventDetails = res;
        res.invitedEmails = this.invitedEmails;
        this.dialogRef.close(res);
        this.toast.info(
          'Successfully created Group',
          {
            theme: 'snackbar',
            position: 'top-right',
            duration: 3000
          }
        );
      }, err => {
        this.toast.info(
          err.error,
          {
            theme: 'snackbar',
            position: 'top-right',
            duration: 3000
          }
        );
      });
    }
  }

  getCreaticsUsers() {
    this.groupSharingService.createCustomRoomId().subscribe((res) => {

    }, err => {

    })
  }

  filter(val: string): Observable<any[]> {
    // call the service which makes the http-request
    this.invitationEmail.setValue(this.myControl.value, { onlySelf: true, emitEvent: true });
    if (val.length > 2) {
      return this.groupSharingService.getPublicUsersList(val)
        .pipe(
          map(response => response.filter(option => {
            let item: any = ''
            if (localStorage.getItem('userData')) {
              item = JSON.parse(localStorage.getItem('userData'))
            }
            return (option.userId != item.userId && !this.selectedUsers.find((p) => p.id == option.userId))
          })),
          map(response => {
            this.filterHasLength = !!response.length;
            
            const check = this.invitationEmail.value
            
            const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

            if (emailRegex.test(check)) {
              console.log("valid email address");
              this.email = true
            } else {
              console.log("Invalid email address");
              this.email = false
            }
            if(check === this.userEmail){
              this.email = false
            }
            if (this.invitationEmail.value && !this.filterHasLength && this.email) {
              this.toast.info(
                `User not found on the Creatics Platform. Please click on the 'Invite User' button to invite them.`,
                {
                  theme: 'snackbar',
                  position: 'top-right',
                  duration: 3000
                }
              );
            }

            if (this.invitationEmail.value && !this.filterHasLength && !this.email) {
  

              if(check === this.userEmail){
                this.email = false
  
                this.toast.info(
                  `You can't invite yourself!`,
                  {
                    theme: 'snackbar',
                    position: 'top-right',
                    duration: 3000
                  }
                );
  
              }
              else{
                this.toast.info(
                  `Please enter valid email address`,
                  {
                    theme: 'snackbar',
                    position: 'top-right',
                    duration: 2000
                  }
                );
              }
            }

            

            return response;
          })
        )
    }
    return EMPTY;
  }

  add(event): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.selectedUsers.push(value);
    }

    // Clear the input value
    //event.!.clear();

    this.myControl.setValue(null);
  }

  remove(fruit: any): void {
    const index = this.selectedUsers.indexOf(fruit);
    const idIndex = this.selectedUsers.indexOf(fruit);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
      this.selectedUsersIds.splice(idIndex, 1)
    }
    // if (this.exsistingGroup) {
    //   let obj = {
    //     "partyType": "PRIVATE",
    //     "customRoomId": this.eventDetails.customRoomId,
    //     "eventId": this.eventDetails.eventId,
    //     "userIds": [
    //       fruit.id
    //     ]
    //   }
    //   this.groupSharingService.removeParticipants(obj).subscribe((res) => {
    //     // this.bottomSheet.dismiss()
    //     this.toast.info(
    //       `User has been sucessfully removed.`,
    //       {
    //         theme: 'snackbar',
    //         position: 'top-right',
    //         duration: 3000
    //       }
    //     );
    //   }, err => {
    //     this.toast.info(
    //       err.error,
    //       {
    //         theme: 'snackbar',
    //         position: 'top-right',
    //         duration: 3000
    //       }
    //     );
    //   })
    // }
  }

  selectedItems(event): void {
    if (!this.selectedUsers.find((v) => v.id == event.option.value)) {
      this.selectedUsersIds.push(event.option.value)
      this.selectedUsers.push({ id: event.option.value, name: event.option.viewValue });
      //this.filter('')
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filter(val || '')
        })
      )

    } else {
      this.openSnackBar('User already selected', '')

    }

    this.userDetailsInput.nativeElement.value = '';
    this.myControl.setValue(null);
  }

  getHostToken() {
    this.groupSharingService.getHostToken(this.eventDetails.eventId, this.eventDetails.customRoomId).subscribe((res) => {
      res.startMeeting = true;
      res.entryRequested = false;
      res.meetingId = this.eventDetails.roomId,
        res.eventId = this.eventDetails.eventId,
        res.customRoomId = this.eventDetails.customRoomId,
        res.isMeetingJoined = true
      res.isAdmin = true;
      res.invitedEmails = this.invitedEmails;

      this.dialogRef.close(res)
    }, err => {

    })
  }

  getActiveParties() {
    this.loading = true;
    this.groupSharingService.getActiveWatchParty(this.data.eventId).subscribe((res) => {

      let item: any = '';
      this.loading = false;
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      item['userId'] = item.userID ? item.userID : item.userId
      if (res.filter((v) => v.userId == item.userId).length > 0) {
        this.eventDetails = res.find((v) => v.userId == item.userId);
        this.groupName = this.eventDetails.description;
        this.eventDetails.participants.map((v) => {
          this.selectedUsersIds.push(v.userId)
          this.selectedUsers.push({ id: v.userId, name: v.userName === 'Invited User .' ? v.userEmail : v.userName });
        })


        this.exsistingGroup = true;
      } else {
        this.exsistingGroup = false;
      }
    }, err => {

    })
  }

  joinExsistingGroup() {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.getHostToken()
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
      this.permissionAllowed = false;

    });

  }

  checkValidValue(event) {

    if (event.value.length > 2 && this.isFormSubmitted) {
      this.invalidGroupName = false;
    }

  }

  getLocalStream() {
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
      this.permissionAllowed = true;
    }).catch((err) => {
      console.error(`you got an error: ${err}`)
      this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
      this.permissionAllowed = false;

    });
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }

  canUserAccessMovie: boolean = false;
  message

  getStreamingLink(): void {
    this.spotlightService.getAgilitixStreamingLink(this.data.eventId).subscribe((response) => {
      this.loading = false;
      if (response.Error !== undefined) {
        // TODO: message pending
        //   this.streamLink = 'https://player.vimeo.com/video/516347937?quality=1080p';
        // this.canUserAccessMovie = true;
        this.canUserAccessMovie = false;
        this.message = response.Error;
      } else if (response.AccessStatus === 'AccessValid') {
        // this.streamLink = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed';
        // const url = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed';
        //  this.streamLink = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.canUserAccessMovie = true;
        this.getActiveParties()
      } else if (response.AccessStatus === 'BeforeEvent') {
        this.canUserAccessMovie = false;
        this.getActiveParties()
        this.message = 'Spotlight Viewing to occur 1-12 March 2023';
      } else if (response.AccessStatus === 'AccessExpired') {
        this.canUserAccessMovie = false;
        this.getActiveParties()
        this.message = 'Your access to this movie is expired. Please purchase the movie again.';
      }
    }, (error: any) => {
      console.log("error in get agiletix customer")
      this.loading = false
      this.canUserAccessMovie = false;
      this.message = 'You do not have access to the movie.';
    });
  }

  redirectUserBuyTicket(): void {
    this.routeUserTo('/cinejoy/premiere/more-info/' + this.cinejoyPremierDetails.eventId + '/' + this.cinejoyPremierDetails.name.replaceAll(' ', '-'));
  }

  routeUserTo(route: any): void {
    this.router.navigate([route], { relativeTo: this.route });
  }

  getPremierInfo() {

    this.spotlightService.getPremierdeatails(this.data.eventId).toPromise().then((responseData: any) => {

      this.cinejoyPremierDetails = responseData
      this.startDate = responseData.cinejoySpotlightsSchedule[0].scheduleTimeText
      this.endDate = responseData.cinejoySpotlightsSchedule[6].scheduleTimeText

      var zone = moment.tz.guess();
      this.timezone = moment(this.startDate).tz(zone).zoneName();
      console.log(this.endDate)
    }, err => {

    })
  }

  getUserDetails() {
    this.spotlightService.getUserDetails().toPromise().then((res: any) => {

      //   this.firstName = (res.firstName).toUpperCase();
      this.userDetails = res;
      this.userEmail = res.email
      res['userId'] = res.userID ? res.userID : res.userId
      localStorage.setItem('userData', JSON.stringify(res));

    }).catch((err: any) => {

    });
  }


  spotlightsTickets: any = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isBuyButtonActive: boolean = false;

  fetchTickets(): void {
    //this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        // this.isLoading = false;
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );
        this.spotlightsTickets = this.spotlightsTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );
        if (this.spotlightsTickets.find((v) => (v.AccessStatus === 'AccessValid' || v.AccessStatus === 'BeforeEvent') && v.ParentID == this.data.eventId)) {
          this.isBuyButtonActive = true;
        }


      },
      (error) => {
        console.log("error in get agiletix customer")
        this.loading = false
        this.isBuyButtonActive = false
      }
    );
  }

  updateEvent() {
    this.loading = true;
    this.isFormSubmitted = true;
    this.invalidUserIds = this.selectedUsersIds.length <= 0 || this.invitedEmails.length <= 0;
    this.invalidGroupName = this.groupName == null || this.groupName.length < 3 || this.groupName.length > 30;


    if (this.invalidGroupName || (this.selectedUsersIds.length <= 0 && this.invitedEmails.length <= 0)) {
      this.loading = false;
      return;
    }
    const obj = {
      "eventId": this.eventDetails.eventId,
      "description": this.groupName,
      "expiryTime": "2023-10-20T11:34:51.513Z",
      "participantIds": this.selectedUsersIds
    }
    this.groupSharingService.updateEvent(obj, this.eventDetails.customRoomId).subscribe((res) => {
      res.invitedEmails = this.invitedEmails;
      this.dialogRef.close(res);
      this.toast.info(
        `Event has been successfully updated.`,
        {
          theme: 'snackbar',
          position: 'top-right',
          duration: 3000
        }
      );
    }, err => {
      this.toast.info(
        err,
        {
          theme: 'snackbar',
          position: 'top-right',
          duration: 3000
        }
      )
    })
  }

  deleteGroup() {
    this.loading = true;
    if (window.confirm('Are sure you want to delete this group ?')) {
      //put your delete method logic here
      this.groupSharingService.deleteEvent(this.eventDetails.customRoomId, this.eventDetails.eventId).subscribe((res) => {
        this.toast.info(
          `Group has been succesfully deleted.`,
          {
            theme: 'snackbar',
            position: 'top-right',
            duration: 3000
          }
        );
        this.loading = false
        this.closeDialog()
      }, err => {
        this.toast.info(
          err.error,
          {
            theme: 'snackbar',
            position: 'top-right',
            duration: 3000
          }
        );
        this.loading = false;
      })
    } else {
      this.loading = false
    }

  }


}
